<div class="reusable-tabs">
    <button
      *ngFor="let tab of tabs"
      [class.active]="activeTab === tab.name"
      [ngStyle]="{ 'background-color': tabBackgroundColor }"
      (click)="switchTab(tab.name)"
    >
      {{ tab.text }}
    </button>
  </div>